export default __webpack_public_path__ + "static/media/iconoir_flashDark.cacf8c7f.svg";